var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEnvelopeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 26,
    viewBox: "0 0 40 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_111_815)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.8757 21.6878L27.7611 13.8034L39.7523 25.7943H23.9821H15.7692H0L11.9909 13.8034L19.8757 21.6878ZM0.456055 0.206055L19.8753 19.6247L39.2949 0.206055H0.456055ZM0 22.8861L10.2946 12.5905L0 2.2959V22.8861ZM40 23.8708L28.7197 12.5905L40 1.31055V23.8708Z",
    fill: "#FF9966"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_111_815"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 25.5882,
    fill: "white",
    transform: "translate(0 0.206055)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnvelopeIcon);
export default __webpack_public_path__ + "static/media/envelope-icon.95580b356dde42bf2907d2020499aa97.svg";
export { ForwardRef as ReactComponent };